import React from 'react';

import ShimmerComponent from '../../../shimmerComponent/shimmerComponent';

import './incomingMsgShimmerComponent.css';

const IncomingMsgShimmerComponent = () => {
  return (
    <div>
      <div className="et-v2-imsc-incoming-msg">
        <ShimmerComponent />
      </div>
      <div className="et-v2-imsc-incoming-msg-time">
        <ShimmerComponent />
      </div>
    </div>
  );
};

export default IncomingMsgShimmerComponent;
